import React, { Component } from "react";
import BreadcrumbCustomer from "../breadcrumb";
import {  Form, Input, Select, Button,message,Divider} from 'antd';
import {dbFields} from '../../model/role/column';
import { route } from '../../routes/routes';
import { CreateRole } from "../../model/role/requests";
import { configs } from "../../config/config";
import storage from '../../utils/storage';



export const layout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 14,
    },
};
const Option = Select.Option;
export const tailLayout = {
    wrapperCol: {
      offset: 8,
      span: 16,
    },
};




export default class RoleCreate extends Component {
    formRef = React.createRef();
    constructor(props){
        super(props)
        this.state = {
            menu:""

        }
    }
    componentWillUnmount(){
        if (!storage.check(configs.cache.tokenKey)) {
            this.props.history.push("/")
        }
    }
    handlerSubmit = (e)=>{
        let name = this.formRef.current.getFieldValue(dbFields.name.key);
        let menu = (this.state.menu === "" ) ? "default" :this.state.menu
        CreateRole({name:name,menu:menu}).then(res=>{
            if(res.data.code === 200){
                message.success(configs.http.responseMsg.created)

                setTimeout(()=>{
                    this.props.history.push(route.role.index)
                },1000)
            
            }else{
                message.error(res.data.msg)
            }
        }).catch(err=>{
            message.error(err)
        })
    }

    handlerMenuPermsChange = (record) => {
        this.setState({
            menu:record
        })
    }

    render(){
        return (
            <>
               <BreadcrumbCustomer   first='Group' second='Create' />
              <Divider />
                <Form
                    {...layout}
                    ref={this.formRef}
                    initialValues={{
                        remember: true,
                    }}
                >
                        <Form.Item
                            name= {dbFields.name.key}
                            label={dbFields.name.title}
                    
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item label="Menu Permission" name="perms">
                        <Select 
                            onChange={this.handlerMenuPermsChange}
                        >
                            { configs.menuPermsList.map((items) => {
                                 return (<Option  attr={items.id} key={items.id} value={items.id}> {items.name} </Option>)
                            })}
                        </Select>
                        </Form.Item>
                        <Form.Item
                            wrapperCol={{
                                span: 12,
                                offset: 6,
                              }}
                        >
                            <Button 
                            type="primary" 
                            style={{background: "#851dd6",color:"white" }}
                            onClick = {this.handlerSubmit}
                            >
                                Submit
                            </Button>
                        </Form.Item>    
                </Form>    
            
            </>
        )
    }
}